export default __webpack_public_path__ + "db167e508daf967bfa0516d7f234d1d9.png";